// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table th {
    background-color: #0b2d71;
    color: white;
    font-weight: bold;
}

.title {
    background-color: #6699cc;
    color: #ffffff;
    padding: 10px;
    text-align: center;
    font-size: 100%; 
}
.title h3 {
    color: white !important;
    text-align: left;
    margin-top: auto;
    margin-bottom: auto;
    }
th, td {
    border: 1px solid white;
    text-align: center;
    padding: 8px;
}
.table-container {
    overflow-x: auto;
  }
  .noDataMessage{
    font-size: 115%;
     color: red;
     font-weight: bolder;
     justify-content: center;
     align-items: center;
  }
  .center-content {
    margin: auto !important;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/temporaryredelegation/approveredelegation/approveredelegation.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;IACI,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,gBAAgB;EAClB;EACA;IACE,eAAe;KACd,UAAU;KACV,mBAAmB;KACnB,uBAAuB;KACvB,mBAAmB;EACtB;EACA;IACE,uBAAuB;IACvB,kBAAkB;AACtB","sourcesContent":["table th {\n    background-color: #0b2d71;\n    color: white;\n    font-weight: bold;\n}\n\n.title {\n    background-color: #6699cc;\n    color: #ffffff;\n    padding: 10px;\n    text-align: center;\n    font-size: 100%; \n}\n.title h3 {\n    color: white !important;\n    text-align: left;\n    margin-top: auto;\n    margin-bottom: auto;\n    }\nth, td {\n    border: 1px solid white;\n    text-align: center;\n    padding: 8px;\n}\n.table-container {\n    overflow-x: auto;\n  }\n  .noDataMessage{\n    font-size: 115%;\n     color: red;\n     font-weight: bolder;\n     justify-content: center;\n     align-items: center;\n  }\n  .center-content {\n    margin: auto !important;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
